export default function nomPrenomGetter(objectAvecNomPrenom) {
  let nomPrenom = '';
  if (objectAvecNomPrenom.nom
    && objectAvecNomPrenom.nom !== undefined) {
    nomPrenom += objectAvecNomPrenom.nom;
  }

  if (objectAvecNomPrenom.prenom
    && objectAvecNomPrenom.prenom !== undefined) {
    nomPrenom += ' ' + objectAvecNomPrenom.prenom;
  }
  return nomPrenom.trim();
}



// WEBPACK FOOTER //
// ./src/services/general/nomPrenomGetter.js